<p-button
  text
  rounded
  severity="secondary"
  [icon]="currentIcon()"
  (click)="togglePopover($event)"
></p-button>

<p-popover #popover>
  <div class="flex flex-col w-full">
    @for (option of modeOptions; track option.value) {
      <p-button
        text
        size="small"
        class="justify-start text-start"
        [severity]="option.value === mode() ? 'primary' : 'secondary'"
        [label]="option.label"
        [icon]="option.icon"
        (click)="setMode(option.value)"
      ></p-button>
    }
  </div>
</p-popover>
